import React from 'react';
import Navbar from '../components/Navbar';
import InnerLeadBanner from '../components/InnerLeadBanner';

const PrivacyPolicy = () => {
    return (
        <>
            <Navbar/>
            <InnerLeadBanner title='Privacy Policy' />
            
            <section className="privacy-policy-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="privacy-content">
                                <div className="last-updated">
                                    <p><strong>Last Updated:</strong> October 28, 2023</p>
                                </div>
                                
                                <div className="intro-section mb-5">
                                    <h2>Welcome to JobFlow</h2>
                                    <p>
                                        At JobFlow Online ("we," "our," or "us"), we are committed to protecting 
                                        your privacy and ensuring the security of your personal information. This 
                                        Privacy Policy explains how we collect, use, disclose, and safeguard your 
                                        information when you use our website and services.
                                    </p>
                                    <p>
                                        By accessing or using JobFlow Online, you consent to the practices described 
                                        in this Privacy Policy. If you do not agree with our policies and practices, 
                                        please do not use our services.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>1. Information We Collect</h3>
                                    
                                    <h4>1.1 Personal Information</h4>
                                    <p>We may collect the following types of personal information:</p>
                                    <ul>
                                        <li><strong>Account Information:</strong> Name, email address, phone number, password</li>
                                        <li><strong>Profile Information:</strong> Resume/CV, work experience, education, skills, photo</li>
                                        <li><strong>Job Application Data:</strong> Cover letters, application history, responses to employer questions</li>
                                        <li><strong>Employer Information:</strong> Company details, contact information, job postings</li>
                                        <li><strong>Payment Information:</strong> Billing details for premium services (processed securely through third-party providers)</li>
                                    </ul>

                                    <h4>1.2 Automatically Collected Information</h4>
                                    <p>When you visit our website, we may automatically collect:</p>
                                    <ul>
                                        <li>IP address and device information</li>
                                        <li>Browser type and version</li>
                                        <li>Pages visited and time spent on pages</li>
                                        <li>Referring website addresses</li>
                                        <li>Cookies and similar tracking technologies</li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>2. How We Use Your Information</h3>
                                    <p>We use the information we collect for the following purposes:</p>
                                    <ul>
                                        <li>To create and maintain your account</li>
                                        <li>To match job seekers with relevant opportunities</li>
                                        <li>To enable employers to post jobs and review applications</li>
                                        <li>To communicate with you about our services, updates, and opportunities</li>
                                        <li>To improve our website and user experience</li>
                                        <li>To prevent fraud and ensure security</li>
                                        <li>To comply with legal obligations</li>
                                        <li>To send promotional communications (with your consent)</li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>3. Information Sharing and Disclosure</h3>
                                    <p>We may share your information in the following circumstances:</p>
                                    
                                    <h4>3.1 With Employers</h4>
                                    <p>
                                        When you apply for a job, we share your application materials 
                                        (resume, cover letter, responses) with the respective employer.
                                    </p>

                                    <h4>3.2 With Job Seekers</h4>
                                    <p>
                                        Employer contact information and job details are visible to job seekers 
                                        applying for positions.
                                    </p>

                                    <h4>3.3 Service Providers</h4>
                                    <p>
                                        We may share information with third-party service providers who 
                                        assist us in operating our website and providing services (e.g., 
                                        hosting, analytics, payment processing).
                                    </p>

                                    <h4>3.4 Legal Requirements</h4>
                                    <p>
                                        We may disclose information when required by law or to protect 
                                        our rights, property, or safety.
                                    </p>

                                    <h4>3.5 Business Transfers</h4>
                                    <p>
                                        In the event of a merger, acquisition, or sale of assets, 
                                        user information may be transferred to the new entity.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>4. Cookies and Tracking Technologies</h3>
                                    <p>
                                        We use cookies and similar technologies to enhance your experience, 
                                        analyze website traffic, and personalize content. You can control 
                                        cookie preferences through your browser settings.
                                    </p>
                                    <p><strong>Types of cookies we use:</strong></p>
                                    <ul>
                                        <li><strong>Essential Cookies:</strong> Required for basic website functionality</li>
                                        <li><strong>Performance Cookies:</strong> Help us understand how visitors use our site</li>
                                        <li><strong>Functionality Cookies:</strong> Remember your preferences and settings</li>
                                        <li><strong>Advertising Cookies:</strong> Deliver relevant advertisements</li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>5. Data Security</h3>
                                    <p>
                                        We implement appropriate technical and organizational security measures 
                                        to protect your personal information against unauthorized access, 
                                        alteration, disclosure, or destruction. These measures include:
                                    </p>
                                    <ul>
                                        <li>SSL encryption for data transmission</li>
                                        <li>Secure server infrastructure</li>
                                        <li>Regular security assessments</li>
                                        <li>Access controls and authentication</li>
                                        <li>Employee training on data protection</li>
                                    </ul>
                                    <p>
                                        However, no method of transmission over the Internet or electronic 
                                        storage is 100% secure, and we cannot guarantee absolute security.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>6. Your Rights and Choices</h3>
                                    <p>You have the following rights regarding your personal information:</p>
                                    <ul>
                                        <li><strong>Access:</strong> Request a copy of your personal data</li>
                                        <li><strong>Correction:</strong> Update or correct inaccurate information</li>
                                        <li><strong>Deletion:</strong> Request deletion of your personal data</li>
                                        <li><strong>Objection:</strong> Object to certain processing activities</li>
                                        <li><strong>Restriction:</strong> Request limitation of processing</li>
                                        <li><strong>Portability:</strong> Request transfer of your data to another service</li>
                                        <li><strong>Withdraw Consent:</strong> Withdraw previously given consent</li>
                                    </ul>
                                    <p>
                                        To exercise these rights, please contact us at 
                                        <a href="mailto:privacy@jobflowonline.com"> privacy@jobflowonline.com</a>.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>7. Data Retention</h3>
                                    <p>
                                        We retain your personal information for as long as necessary to 
                                        fulfill the purposes outlined in this Privacy Policy, unless a 
                                        longer retention period is required or permitted by law.
                                    </p>
                                    <p><strong>Retention periods:</strong></p>
                                    <ul>
                                        <li><strong>Active accounts:</strong> Until account deletion request</li>
                                        <li><strong>Job applications:</strong> 2 years from last activity</li>
                                        <li><strong>Employer job postings:</strong> 1 year after position filled</li>
                                        <li><strong>Financial records:</strong> 7 years for tax purposes</li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>8. International Data Transfers</h3>
                                    <p>
                                        JobFlow Online is based in Ghana and may process and store your 
                                        information in Ghana or other countries. By using our services, 
                                        you consent to the transfer of your information to countries 
                                        that may have different data protection laws than your country 
                                        of residence.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>9. Children's Privacy</h3>
                                    <p>
                                        Our services are not intended for individuals under the age of 16. 
                                        We do not knowingly collect personal information from children. 
                                        If we become aware that we have collected personal information 
                                        from a child without parental consent, we will take steps to 
                                        remove that information.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>10. Third-Party Links</h3>
                                    <p>
                                        Our website may contain links to third-party websites. This 
                                        Privacy Policy does not apply to those websites, and we are 
                                        not responsible for their privacy practices. We encourage 
                                        you to review the privacy policies of any third-party sites 
                                        you visit.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>11. Changes to This Privacy Policy</h3>
                                    <p>
                                        We may update this Privacy Policy from time to time to reflect 
                                        changes in our practices or legal requirements. We will notify 
                                        you of any material changes by posting the new Privacy Policy 
                                        on our website and updating the "Last Updated" date.
                                    </p>
                                    <p>
                                        Your continued use of our services after any changes indicates 
                                        your acceptance of the updated Privacy Policy.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3>12. Contact Us</h3>
                                    <p>
                                        If you have any questions, concerns, or requests regarding this 
                                        Privacy Policy or our data practices, please contact us:
                                    </p>
                                    <div className="contact-info">
                                        <p><strong>Email:</strong> <a href="mailto:privacy@jobflowonline.com">privacy@jobflowonline.com</a></p>
                                        <p><strong>Phone:</strong> +233 559 801 548</p>
                                        <p><strong>Address:</strong> 
                                            <br />
                                            JobFlow Online
                                            <br />
                                            PMB CT 243, Cantonments
                                            <br />
                                            Accra, Ghana
                                        </p>
                                    </div>
                                </div>

                                <div className="policy-section">
                                    <h3>13. Governing Law</h3>
                                    <p>
                                        This Privacy Policy shall be governed by and construed in 
                                        accordance with the laws of the Republic of Ghana. Any disputes 
                                        arising from this policy shall be subject to the exclusive 
                                        jurisdiction of the courts of Ghana.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .privacy-policy-section {
                    padding: 50px 0;
                    background-color: #f8f9fa;
                }
                
                .privacy-content {
                    background: white;
                    padding: 40px;
                    border-radius: 10px;
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                }
                
                .last-updated {
                    background: #e9ecef;
                    padding: 15px;
                    border-radius: 5px;
                    margin-bottom: 30px;
                    text-align: center;
                }
                
                .intro-section {
                    border-bottom: 2px solid #667eea;
                    padding-bottom: 20px;
                }
                
                .policy-section h3 {
                    color: #667eea;
                    margin-bottom: 15px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e9ecef;
                }
                
                .policy-section h4 {
                    color: #495057;
                    margin: 15px 0 10px;
                    font-size: 1.1rem;
                }
                
                .policy-section ul {
                    padding-left: 20px;
                    margin-bottom: 15px;
                }
                
                .policy-section li {
                    margin-bottom: 8px;
                    line-height: 1.6;
                }
                
                .policy-section strong {
                    color: #495057;
                }
                
                .contact-info {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 5px;
                    margin-top: 15px;
                }
                
                .contact-info a {
                    color: #667eea;
                    text-decoration: none;
                }
                
                .contact-info a:hover {
                    text-decoration: underline;
                }
                
                @media (max-width: 768px) {
                    .privacy-content {
                        padding: 20px;
                    }
                    
                    .policy-section h3 {
                        font-size: 1.3rem;
                    }
                }
            `}</style>
        </>
    );
};

export default PrivacyPolicy;